/** The model for a given field's data elements */
/**
 * @param {ViewModel} object
 */
export function instanceOfInputViewModel(object) {
    return 'value' in object;
}
/**
 * @param {ViewModel} object
 */
export function instanceOfListViewModel(object) {
    return 'items' in object;
}
